import md5 from 'crypto-js/md5'

import { getApiOrigin } from './api-client/getApiOrigin'
import { isPWA } from './device'

export const getPublicAuth = async () => {
  const key = import.meta.env.VITE_API_KEY
  const res = await fetch(`${getApiOrigin({})}/increase.php?display_platform=${isPWA() ? '2' : '0'}`)
  const serverTime = await res.json() as number
  return md5(`${serverTime.toString().substring(0, 7)}${key}`).toString()
}
